<template>
  <div id="app">
    <Navbar />
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";

export default {
  components: {
    Navbar,
    Footer
  }
};
</script>

<style lang="scss">
html,
body {
  background-color: rgba(0, 0, 0, 0.98) !important;
}
.padding-top {
  padding-top: 3rem !important;
}

.button {
  border-radius: 0 !important;
}

.highlight {
  background-color: #eb272c;
  font-family: inherit;
  // font-weight: bolder !important;
  color: #000 !important;
  display: inline-block;
  padding: 0.2rem !important;
  /* margin-left: -5px; */
  line-height: 1em;
}

.highlighter {
  background-color: #eb272c;
  font-family: inherit;
  font-weight: bolder !important;
  color: #000 !important;
  display: initial;
  padding: 0.2rem !important;
  /* margin-left: -5px; */
  line-height: 1em;
}

.drop-shadow {
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.7) !important;
}

@media screen and (min-width: 1024px) {
  .primary-btn {
    clip-path: polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%) !important;
    margin-right: 10px;
  }
}

@media screen and (max-width: 1023px) {
  .primary-btn {
    clip-path: polygon(10% 0%, 100% 0%, 90% 100%, 0% 100%) !important;
    margin: 10px;
    color: white !important;
    text-align: center !important;
  }
}
.icon-left {
  margin-right: 5px !important;
  margin-left: 2px !important;
}

@media screen and (max-width: 1023px) {
  .navbar-item.primary-btn {
    clip-path: none !important;
  }
}
</style>
